import { ErrorHandler, Injectable, Injector} from '@angular/core';
import { UserService } from '@services/user/user.service';
import { environment } from '@environments/environment';
import { captureException } from "@sentry/angular-ivy";
import { InjectOptions } from '@angular/core';

@Injectable()
export class GlobalErrorHandler extends  ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }
  handleError(error) {

    //If a chunk fails, we test for it here. We want to reload the page instead of log an error in this case
    //I dont know why, someone else added this...
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;    
    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }

    try {
      if (environment.production) {
        const options: InjectOptions = {
          host: false,
          optional: false,
          skipSelf: false,
          self: false
        };

        const userService: UserService = this.injector.get(UserService, null, options);
        userService.getCurrentUser().subscribe((res: any) => {
          const user = res.json.data;
          captureException(error, {
            tags: {['UserID']:user.id, ['Email']: user.email}
          });
        }, (err) => {
          try {
            captureException(error);
          } catch (e) {
  
          }
        });
      }
    } catch (e) {
      if (environment.production) {
        try {
          captureException(error);
        } catch (e) {

        }
      }
    } finally {
      super.handleError(error);
    }

  }

}
